import React from 'react';
import { FeatureIntroductionBanner } from '@components/notifications/banner/Banners';
import { Text, Heading } from '@amzn/storm-ui';
import {
  REGISTRATION_GENERAL_INFO_BANNER_MESSAGE_TRANSLATION_KEY,
  REGISTRATION_GENERAL_INFO_BANNER_TITLE_TRANSLATION_KEY,
} from '@features/account-registration/constants';
import useIntl from '@i18n/useIntl';
import { useSelector } from 'react-redux';
import { RootState } from 'src/shared/state/store';
import { HMHAnchor } from '@amzn/help-me-here-client';

interface RegistrationGeneralInfoBannerProps {
  id: string;
}

const RegistrationGeneralInfoBanner = ({
  id,
}: RegistrationGeneralInfoBannerProps) => {
  const { intl } = useIntl();
  const alerts = useSelector((state: RootState) => state.alert.alerts);

  // If we have alerts, we do not want to display this component; we should let the alert banner be displayed instead.
  if (alerts.length > 0) {
    return null;
  }
  return (
    <FeatureIntroductionBanner id={id} duration={0}>
      <>
        <Heading renderAs="h4">
          {intl.getMessage(
            REGISTRATION_GENERAL_INFO_BANNER_TITLE_TRANSLATION_KEY,
          )}
        </Heading>
        <Text>
          {intl.getMessage(
            REGISTRATION_GENERAL_INFO_BANNER_MESSAGE_TRANSLATION_KEY,
          )}
        </Text>
        <HMHAnchor contentId="GEABRS583GD87CLZ-GV4VBGPACU64WYCF" />
      </>
    </FeatureIntroductionBanner>
  );
};

export default RegistrationGeneralInfoBanner;
